import { nanoid } from 'nanoid';

export type TrackingIdentifier = string & {
  _brand: 'trackingId';
};

// this char shouldn't be in alphabet of generator of id
// Used for marking Sequenced flow which is completed. Used to safe space in external storages
const _shortSeqFlowPostfix = '*';

export function generateTrackingIdentifier(): TrackingIdentifier {
  return nanoid(8);
}

export function addSequencedFlowPostfix(trackingId: TrackingIdentifier): TrackingIdentifier {
  return (trackingId + _shortSeqFlowPostfix) as TrackingIdentifier;
}

type RemovedSequencedFlowPostfixResult = {
  trackingIdentifier: TrackingIdentifier;
  wasRemoved: true;
};
type NotRemovedSequencedFlowPostfixResult = { wasRemoved: false };
export type TryRemoveSequencedFlowPostfixResult =
  | RemovedSequencedFlowPostfixResult
  | NotRemovedSequencedFlowPostfixResult;

export function tryRemoveSequencedFlowPostfix(trackingId: TrackingIdentifier): TryRemoveSequencedFlowPostfixResult {
  if (trackingId.endsWith(_shortSeqFlowPostfix)) {
    const trackingIdWithoutPostfix = trackingId.substring(0, trackingId.length - _shortSeqFlowPostfix.length);
    return {
      trackingIdentifier: trackingIdWithoutPostfix as TrackingIdentifier,
      wasRemoved: true,
    };
  }

  return {
    wasRemoved: false,
  };
}
